import PropTypes from "prop-types";
import styles from "./CategoryHeader.css";
import CategoryHeaderDescription from "./CategoryHeaderDescription";
import CategoryHeaderLinks from "./CategoryHeaderLinks/CategoryHeaderLinks";
import CategoryHeaderTitle from "./CategoryHeaderTitle";
import { CATEGORY_BANNER_ID } from "../constants";

export const CategoryHeader = ({ hasHeaderLinks, hasVisualCategories }) => (
  <section id={CATEGORY_BANNER_ID} className={styles.wrapper}>
    <div className={styles.textWrapper}>
      <div className={styles.titleHeaderWrapper}>
        <CategoryHeaderTitle hasVisualCategories={hasVisualCategories} />
        {!hasVisualCategories && (
          <CategoryHeaderDescription device="mobileOnly" />
        )}
        {hasHeaderLinks && <CategoryHeaderLinks />}
      </div>

      {!hasVisualCategories && (
        <CategoryHeaderDescription device="desktopOnly" />
      )}
    </div>
  </section>
);

CategoryHeader.propTypes = {
  hasHeaderLinks: PropTypes.bool.isRequired,
  hasVisualCategories: PropTypes.bool.isRequired
};

export default CategoryHeader;
